import { browserHistory } from 'react-router';
import { updateLanguage } from 'react-localize-redux';
import store from 'store';
import constants from 'config/constants';
import { getCompanyPreferences } from 'actions/companyDetailsActions';
import { getPortfolios } from 'actions/landlordPropertiesActions';
import * as authentication from 'actions/authenticationActions';
import * as redirection from 'actions/redirectionActions';
import * as notifications from 'actions/notificationActions';
import * as userTypes from 'actions/userTypesActions';
import { dashboardForAgent } from 'helpers/RouterHelper';
import { featureEnabled } from 'helpers/ToggleBot';

export function onAuthenticationSuccess(response) {
  const currentLocation = browserHistory.getCurrentLocation();
  const query = currentLocation.query;

  // The condition below is for when
  // A application invitation link is clicked from a browser with an exisiting active session
  if (currentLocation.pathname === '/user_onboarding' && query.has_signed_up === 'false') {
    localStorage.clear();
    window.location.reload();
  }

  if (response.feature_set) {
    store.dispatch(
      userTypes.setLandlordDetails({
        landlordName: response.landlord_name,
        id: response.landlord_id,
        accentColor: response.accent_color,
        landlordLogoUrl: response.logo_url || response.landlord_logo_url,
        landlordSSOEnabled: response.landlord_sso_enabled,
        uuid: response.uuid,
        propertyTypes: response.property_types,
        landlordLogoThumbUrl: response.logo_thumb_url || response.landlord_logo_thumb_url,
        sso_providers: response.sso_providers,
        verbiages: response.verbiages,
        showPoweredByYuhu: response.show_powered_by_yuhu,
        heroImageUrl: response.hero_image_url,
        featureSet: response.feature_set,
        defaultLanguages: response.default_languages,
        countryCodes: response.country_codes,
        greetingNameType: response.greeting_name_type,
        googleTagId: response.google_tag_id,
        landlordCountry: response.landlord_country,
        leadManagingLink: response.lead_managing_link,
      })
    );
  }

  if (response.landlord_logo_url) {
    store.dispatch(
      userTypes.setLandlordLogo(response.landlord_logo_url, response.landlord_logo_thumb_url)
    );
  }

  if (response.language_code) {
    store.dispatch(updateLanguage(response.language_code));
    localStorage.setItem('locale', response.language_code);
  }

  if (response.default_languages) {
    store.dispatch(userTypes.setDefaultLanguages(response.default_languages));
  }

  if (response.accent_color) {
    store.dispatch(userTypes.setAccentColor(response.accent_color));
  }

  if (currentLocation.pathname.startsWith('/companies')) {
    store.dispatch(getCompanyPreferences());
    store.dispatch(getPortfolios());
  }

  window.gtag('config', 'GA_MEASUREMENT_ID', {
    page_path: currentLocation.pathname,
  });

  if (currentLocation.pathname === '/companies/billing') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/billing${currentLocation.search}`);
  } else if (currentLocation.pathname.startsWith('/companies/notices')) {
    const noticeID = currentLocation.pathname.match(/\d+/);
    store.dispatch(userTypes.setUserAsLandlord(response));

    if (noticeID && currentLocation.pathname === `/companies/notices/${noticeID[0]}`) {
      browserHistory.push(`/companies/notices/${noticeID}`);
    } else {
      browserHistory.push(`/companies/notices${currentLocation.search}`);
    }
  } else if (currentLocation.pathname === '/companies/tenants') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/tenants${currentLocation.search}`);
  } else if (currentLocation.pathname.startsWith('/companies/rent_roll')) {
    const leaseId = currentLocation.pathname.match(/\d+/);

    if (currentLocation.pathname === '/companies/rent_roll') {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push('/companies/rent_roll' + currentLocation.pathname.search);
    } else if (leaseId && currentLocation.pathname === `/companies/rent_roll/${leaseId[0]}`) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/rent_roll/${leaseId[0]}`);
    }
  } else if (currentLocation.pathname.startsWith('/companies/document_templates')) {
    const documentTemplateId = currentLocation.pathname.match(/\d+/);

    if (currentLocation.pathname === '/companies/document_templates') {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/document_templates${currentLocation.search}`);
    } else if (
      documentTemplateId &&
      currentLocation.pathname === `/companies/document_templates/${documentTemplateId[0]}`
    ) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/document_templates/${documentTemplateId}`);
    }
  } else if (currentLocation.pathname === '/companies/assets') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/assets${currentLocation.search}`);
  } else if (currentLocation.pathname === '/companies/charges') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/charges${currentLocation.search}`);
  } else if (currentLocation.pathname === '/companies/amenities') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/amenities${currentLocation.search}`);
  } else if (featureEnabled('ui.fees') && currentLocation.pathname === '/companies/fees') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/fees${currentLocation.search}`);
  } else if (
    featureEnabled('ui.incentives') &&
    currentLocation.pathname === '/companies/incentives'
  ) {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/incentives${currentLocation.search}`);
  } else if (currentLocation.pathname === '/companies/promotions') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/promotions${currentLocation.search}`);
  } else if (currentLocation.pathname === '/companies/events') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/events${currentLocation.search}`);
  } else if (currentLocation.pathname.startsWith('/vendor_maintenance_ticket')) {
    browserHistory.push(`/vendor_maintenance_ticket${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname.startsWith('/companies/maintenance/tickets')) {
    const ticketID = currentLocation.pathname.match(/\d+/);

    if (ticketID && currentLocation.pathname === `/companies/maintenance/tickets/${ticketID[0]}`) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/maintenance/tickets/${ticketID}`);
    } else {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/maintenance/tickets${currentLocation.search}`);
    }
  } else if (currentLocation.pathname === '/companies/ticket_scheduler') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/ticket_scheduler${currentLocation.search}`);
  } else if (currentLocation.pathname.startsWith('/companies/purchase_orders')) {
    const purchaseOrderId = currentLocation.pathname.match(/\d+/);

    if (
      purchaseOrderId &&
      currentLocation.pathname === `/companies/purchase_orders/${purchaseOrderId[0]}`
    ) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/purchase_orders/${purchaseOrderId}`);
    } else {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/purchase_orders${currentLocation.search}`);
    }
  } else if (currentLocation.pathname.startsWith('/companies/maintenance/projects')) {
    const projectID = currentLocation.pathname.match(/\d+/);

    if (
      projectID &&
      currentLocation.pathname === `/companies/maintenance/projects/${projectID[0]}`
    ) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/maintenance/projects/${projectID}`);
    } else {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/maintenance/projects${currentLocation.search}`);
    }
  } else if (currentLocation.pathname.startsWith('/companies/batches')) {
    const batchId = currentLocation.pathname.match(/\d+/);

    if (batchId && currentLocation.pathname === `/companies/batches/${batchId[0]}`) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/batches/${batchId[0]}`);
    } else {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/batches${currentLocation.search}`);
    }
  } else if (currentLocation.pathname === '/companies/properties') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/properties${currentLocation.search}`);
  } else if (currentLocation.pathname === '/companies/users') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/users${currentLocation.search}`);
  } else if (currentLocation.pathname === '/document_portal_in_person') {
    browserHistory.push(`/document_portal_in_person${currentLocation.search}`);
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/document_portal') {
    browserHistory.push(`/document_portal${currentLocation.search}`);
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/renew_lease') {
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/companies/reporting') {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/reporting${currentLocation.search}`);
  } else if (
    featureEnabled('application-management') &&
    currentLocation.pathname === '/companies/application_templates'
  ) {
    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/application_templates`);
  } else if (
    featureEnabled('application-management') &&
    currentLocation.pathname.startsWith('/companies/application_templates')
  ) {
    const application_template_id = currentLocation.pathname.match(/\d+/);
    const step_id = currentLocation.pathname.split('/')[5];

    if (
      currentLocation.pathname ===
        `/companies/application_templates/${application_template_id}/steps` &&
      !step_id
    ) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/application_templates/${application_template_id}/steps`);
    } else if (
      step_id &&
      currentLocation.pathname ===
        `/companies/application_templates/${application_template_id}/steps/${step_id}`
    ) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/application_templates/${application_template_id}/steps`);
    } else {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/application_templates`);
    }
  } else if (currentLocation.pathname.startsWith('/companies/package_form')) {
    const packageId = currentLocation.pathname.match(/\d+/);

    if (packageId && currentLocation.pathname === `/companies/package_form/${packageId[0]}`) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/package_form/${packageId[0]}`);
    } else {
      store.dispatch(userTypes.setUserAsLandlord(response));
      browserHistory.push(`/companies/package_form`);
    }
  } else if (currentLocation.pathname.startsWith('/tenant_change_password_reset')) {
    const params =
      query.reset_password_email === 'true'
        ? 'reset_password_email=true'
        : 'reset_password_email=false';

    store.dispatch(userTypes.setUserAsLead(response));
    browserHistory.push(`/tenant_change_password_reset?${params}`);
  } else if (
    currentLocation.pathname.startsWith('/maintenance/maintenance_change_password_reset')
  ) {
    const params =
      query.reset_password_email === 'true'
        ? 'reset_password_email=true'
        : 'reset_password_email=false';

    store.dispatch(userTypes.setUserAsMaintenance(response));
    browserHistory.push(`/maintenance/maintenance_change_password_reset?${params}`);
  } else if (currentLocation.pathname.startsWith('/companies/agent_change_password_reset')) {
    const params =
      query.reset_password_email === 'true'
        ? 'reset_password_email=true'
        : 'reset_password_email=false';

    store.dispatch(userTypes.setUserAsLandlord(response));
    browserHistory.push(`/companies/agent_change_password_reset?${params}`);
  } else if (currentLocation.pathname === '/tenant_application') {
    browserHistory.push(`/tenant_application${currentLocation.search}`);
  } else if (currentLocation.pathname === '/internal_document_portal') {
    browserHistory.push(`/internal_document_portal${currentLocation.search}`);
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/profile') {
    browserHistory.push('/profile');
  } else if (currentLocation.pathname === '/tenant_landlord_reference_verification') {
    browserHistory.push(`/tenant_landlord_reference_verification${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/tenant_personal_reference_verification') {
    browserHistory.push(`/tenant_personal_reference_verification${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/tenant_maintenance_verification') {
    browserHistory.push(`/tenant_maintenance_verification${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/survey') {
    browserHistory.push(`/survey${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/book_showing') {
    browserHistory.push(`/book_showing${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/tenant_permission_for_entry') {
    browserHistory.push(`/tenant_permission_for_entry${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/tenant_referral') {
    browserHistory.push(`/tenant_referral${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/lead_capture') {
    browserHistory.push(`/lead_capture${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (query.property_id && query.application_id) {
    browserHistory.push(
      `/tenant_application?property_id=${query.property_id}&application_id=${query.application_id}`
    );
  } else if (query.property_id) {
    browserHistory.push(`/tenant_application?property_id=${query.property_id}`);
  } else if (currentLocation.pathname.startsWith('/companies')) {
    store.dispatch(userTypes.setUserAsLandlord(response));

    // TODO: Refactor this entire file. Currently the else statement of this block will
    // redirect any unspecified route to a dashboard. Example: /companies/dashboard or
    // /companies/api_dashboard_documents
    // We should not have to specify a route here to navigate directly to it. This is silly
    if (currentLocation.pathname.startsWith('/companies/prospects')) {
      browserHistory.push(`/companies/prospects${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/leads')) {
      browserHistory.push(`/companies/prospects${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/showings')) {
      browserHistory.push(`/companies/showings${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/applications')) {
      browserHistory.push(browserHistory.getCurrentLocation().pathname);
    } else if (currentLocation.pathname.startsWith('/companies/incentives')) {
      browserHistory.push(browserHistory.getCurrentLocation().pathname);
    } else if (currentLocation.pathname.startsWith('/companies/lease_creator')) {
      browserHistory.push(`/companies/lease_creator${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/new_lease')) {
      browserHistory.push('/companies/new_lease' + currentLocation.search);
    } else if (currentLocation.pathname.startsWith('/companies/inspections')) {
      browserHistory.push(`/companies/inspections${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/inspection_templates')) {
      browserHistory.push(`/companies/inspection_templates${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/logs')) {
      browserHistory.push(`/companies/logs${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/api_dashboard_documents')) {
      browserHistory.push('/companies/api_dashboard_documents');
    } else if (currentLocation.pathname.startsWith('/companies/overwrite_in_person_lease')) {
      browserHistory.push(`/companies/overwrite_in_person_lease${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/renewal_creator')) {
      browserHistory.push(`/companies/renewal_creator${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/move_out_creator')) {
      browserHistory.push(`/companies/move_out_creator${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/manual_lease_creator')) {
      browserHistory.push(`/companies/manual_lease_creator${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/automation')) {
      browserHistory.push(`/companies/automation${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies/integrations')) {
      browserHistory.push(`/companies/integrations${currentLocation.search}`);
    } else if (currentLocation.pathname === '/companies/internal_document_portal') {
      browserHistory.push(`/companies/internal_document_portal${currentLocation.search}`);
      store.dispatch(authentication.showSignaturePage());
    } else {
      browserHistory.push(dashboardForAgent(response.permission) + currentLocation.search);
    }
  } else if (currentLocation.pathname === '/maintenance/users') {
    store.dispatch(userTypes.setUserAsMaintenance(response));
    browserHistory.push(`/maintenance/users${currentLocation.search}`);
  } else if (currentLocation.pathname.startsWith('/maintenance')) {
    store.dispatch(userTypes.setUserAsMaintenance(response));
    browserHistory.push(`/maintenance/dashboard${currentLocation.search}`);
  } else if (currentLocation.pathname === '/user_onboarding') {
    const query_params = currentLocation.query;

    store.dispatch(userTypes.setUserAsLead());
    store.dispatch(authentication.logUserOut());
    store.dispatch(authentication.showNonAuthPage());
    store.dispatch(
      redirection.receiveInvitationToken(query_params.invitation_token, query_params.user_type)
    );
  } else {
    if (query.email_confirmation) {
      store.dispatch(notifications.showSuccess('emailSuccessfullyConfirmed'));
    }
    if (query.unlocked) {
      store.dispatch(notifications.showSuccess('accountSuccessfullyUnlocked'));
    }
    if (currentLocation.pathname.startsWith('/maintenance')) {
      store.dispatch(userTypes.setUserAsMaintenance(response));
      store.dispatch(authentication.setMaintenanceLoginParams());
      browserHistory.push(`/maintenance/dashboard${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/companies')) {
      store.dispatch(userTypes.setUserAsLandlord(response));
      store.dispatch(authentication.setLandlordLoginParams());
      browserHistory.push(`/companies${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/payment_settings')) {
      browserHistory.push(`/payment_settings${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/promotions')) {
      browserHistory.push(`/promotions${currentLocation.search}`);
    } else {
      store.dispatch(userTypes.setUserAsLead(response));
      browserHistory.push(`/dashboard${currentLocation.search}`);
    }
  }

  return response;
}

export async function onAuthenticationError(error) {
  const currentLocation = browserHistory.getCurrentLocation();
  const query = currentLocation.query;

  const routesThatWillDisplayNonAuthPage = [
    '/tenant_sign_up',
    '/tenant_password_reset',
    '/tenant_change_password_from_email',
    '/book_and_sign_up',
    '/tenant_resend_confirmation',
    '/tenant_landlord_reference_verification',
    '/tenant_personal_reference_verification',
    '/tenant_maintenance_verification',
    '/survey',
    '/book_showing',
    '/tenant_permission_for_entry',
    '/tenant_referral',
    '/lead_capture',
    '/vendor_maintenance_ticket',
  ];

  const routesThatShouldHaveQueryParams = [
    '/tenant_application',
    '/apply_and_sign_up',
    '/user_onboarding',
  ];

  if (constants.SUBDOMAIN) {
    await store.dispatch(userTypes.getLandlordDetails());
  }

  window.gtag('config', 'GA_MEASUREMENT_ID', {
    page_path: currentLocation.pathname,
  });

  if (routesThatWillDisplayNonAuthPage.includes(currentLocation.pathname)) {
    store.dispatch(authentication.showNonAuthPage());
  } else if (
    routesThatShouldHaveQueryParams.includes(currentLocation.pathname) &&
    Object.keys(currentLocation.query).length === 0
  ) {
    // route should have some sort of query param

    browserHistory.push('/');
  } else if (currentLocation.pathname === '/user_onboarding') {
    store.dispatch(authentication.showNonAuthPage());
    const query_params = currentLocation.query;
    store.dispatch(
      redirection.receiveInvitationToken(query_params.invitation_token, query_params.user_type)
    );
  } else if (currentLocation.pathname.startsWith('/application_steps')) {
    let termsConfirmation = localStorage.getItem('terms');
    let selectedUnit = localStorage.getItem('unit');
    let template_id = currentLocation.pathname.split('/')[2];

    if (template_id) {
      if (termsConfirmation !== 'true' || !termsConfirmation) {
        browserHistory.push(`/application_steps/${template_id}/terms_condition`);
      } else {
        if (!selectedUnit) {
          browserHistory.push(`/application_steps/${template_id}/select_unit`);
        }
      }
      store.dispatch(authentication.showNonAuthPage());
    } else {
      browserHistory.push('/');
    }
  } else if (
    currentLocation.pathname === '/maintenance/maintenance_password_reset' ||
    currentLocation.pathname === '/maintenance/maintenance_resend_confirmation' ||
    currentLocation.pathname === '/maintenance/maintenance_change_password_from_email'
  ) {
    store.dispatch(userTypes.setUserAsMaintenance(error));
    store.dispatch(authentication.showNonAuthPage());
  } else if (
    currentLocation.pathname === '/companies/agent_password_reset' ||
    currentLocation.pathname === '/companies/agent_resend_confirmation' ||
    currentLocation.pathname === '/companies/agent_change_password_from_email'
  ) {
    store.dispatch(userTypes.setUserAsLandlord());
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/tenant_referral') {
    browserHistory.push(`/tenant_referral${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/lead_capture') {
    browserHistory.push(`/lead_capture${currentLocation.search}`);
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/apply_and_sign_up') {
    const query_params = currentLocation.query;
    store.dispatch(authentication.showNonAuthPage());
    // redirect to application if property_id is valid
    store.dispatch(
      redirection.redirectToApplication(query_params.property_id, query_params.referrer)
    );
  } else if (currentLocation.pathname === '/tenant_application') {
    if (query.application_id) {
      browserHistory.push('/');
    } else {
      store.dispatch(redirection.redirectToApplication(query.property_id, query.referrer));
    }
    store.dispatch(authentication.showNonAuthPage());
  } else if (currentLocation.pathname === '/document_portal') {
    browserHistory.push(`/document_portal${currentLocation.search}`);
    store.dispatch(authentication.showSignaturePage());
  } else if (currentLocation.pathname === '/document_portal_in_person') {
    browserHistory.push(`/document_portal_in_person${currentLocation.search}`);
    store.dispatch(authentication.showSignaturePage());
  } else {
    store.dispatch(authentication.logUserOut());

    if (query.email_confirmation || query.unlocked) {
      if (query.email_confirmation && !query.catch) {
        store.dispatch(notifications.showSuccess('emailSuccessfullyConfirmed'));
      } else if (query.unlocked && !query.catch) {
        store.dispatch(notifications.showSuccess('accountSuccessfullyUnlocked'));
      } else if (query.email_confirmation && query.catch) {
        store.dispatch(notifications.showFailure('yourEmailHasAlreadyBeenConfirmed'));
      }
      if (currentLocation.pathname.startsWith('/maintenance')) {
        store.dispatch(userTypes.setUserAsMaintenance(error));
        store.dispatch(authentication.setMaintenanceLoginParams());
        browserHistory.push('/maintenance/dashboard');
      } else if (currentLocation.pathname.startsWith('/companies')) {
        store.dispatch(userTypes.setUserAsLandlord());
        store.dispatch(authentication.setLandlordLoginParams());
        browserHistory.push('/companies');
      } else {
        browserHistory.push('/');
      }
    } else if (currentLocation.pathname === '/tenant_referral') {
      browserHistory.push(`/tenant_referral${currentLocation.search}`);
      store.dispatch(authentication.showNonAuthPage());
    } else if (currentLocation.pathname === '/lead_capture') {
      browserHistory.push(`/lead_capture${currentLocation.search}`);
      store.dispatch(authentication.showNonAuthPage());
    } else if (query.property_id && query.application_id && !query.book_date) {
      browserHistory.push(
        `/tenant_application?property_id=${query.property_id}&application_id=${query.application_id}`
      );
    } else if (query.property_id && !query.book_date) {
      browserHistory.push(`/tenant_application?property_id=${this.props.property_id}`);
    } else if (currentLocation.pathname.startsWith('/companies')) {
      store.dispatch(userTypes.setUserAsLandlord());
      store.dispatch(authentication.setLandlordLoginParams());
      browserHistory.push(`/companies${currentLocation.search}`);
    } else if (currentLocation.pathname.startsWith('/maintenance')) {
      store.dispatch(userTypes.setUserAsMaintenance(error));
      store.dispatch(authentication.setMaintenanceLoginParams());
    } else {
      store.dispatch(userTypes.setUserAsLead());
      browserHistory.push(`/${currentLocation.search}`);
    }
  }

  if (error) {
    throw error;
  }
}
